import { ref } from 'vue';

/**
 * Drapeau partagé qui active le « mode étendu » de l'écran de connexion Fondation :
 * le col image de gauche rétrécit et le panneau d'inscription occupe les 3/4 droite.
 * Fourni à la Fondation via provide('loginExpanded'), basculé par le bouton
 * « Nouvelle inscription » et remis à false par le bouton de retour du panneau.
 */
export const loginExpanded = ref(false);
